import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
    value: {
        selectedTagPage: number;
        tagsLoading: boolean;
        globalTags: any;
    }
};

const initialState = {
    value: {
        selectedTagPage: 1,
        tagsLoading: true,
        globalTags: [],
    }
} as InitialState;

export const tagSlice = createSlice({
    name: 'tags',
    initialState,
    reducers: {
        setSelectedTagPageRedux: (state, action) => {
            state.value.selectedTagPage = action.payload;
        },
        setTagsLoadingRedux: (state, action) => {
            state.value.tagsLoading = action.payload;
        },
        setGlobalTagsRedux: (state, action) => {
            state.value.globalTags = action.payload;
        },
    },
});

export const {
    setSelectedTagPageRedux,
    setTagsLoadingRedux,
    setGlobalTagsRedux,
} = tagSlice.actions;
export default tagSlice.reducer;